<template>
    <div class="onlineUsers" :style="getMinWidth">

        <!--Online Users-->
        <template v-for="user in $store.getters.getAllOnlineUsers">
            <div 
                :key="`online_user_${user.uid}`"
                v-if="user.uid !== $store.state.currentUser.uid"
                class="onlineUser"
                @click.prevent="$emit('open-chat', user)"
            >
                <div
                    class="avatar"
                    :style="`background-image:url(${user.photoURL});`"
                >
                    <MemberStatus :memberId="user.uid"></MemberStatus>
                </div>
                <span class="name">{{ user.firstName | checkLongName }}</span>
            </div>
        </template>

        <!--User Friends-->
        <template v-for="(user, userIndex) in getMyFriends">
            <div
                :key="`friend_online_${userIndex}`"
                class="onlineUser"
                @click.prevent="$emit('open-chat', user)"
            >
                <div class="avatar" :style="`background-image:url(${user.photoURL});`">
                    <MemberStatus :memberId="user.uid"></MemberStatus>
                </div>
                <span class="name">{{ user.firstName | checkLongName }}</span>
            </div>
        </template>
    </div>
</template>

<script>
import MemberStatus from '@/components/MemberStatus'

export default {
    name: 'OnlineUsers',

    components: {
        MemberStatus
    },

    computed: {
        getMinWidth(){
            let totalOnlineUsers = Object.keys(this.$store.getters.getAllOnlineUsers).length
            let totalWidth = (totalOnlineUsers * 70) + (this.getMyFriends.length * 70)

            return `width:${totalWidth}px`
        },
        getMyFriends(){
            let myFriends = this.$store.state.userProfileFriends.filter(friend => {
                if(friend.status === 'friends'){
                    return friend
                }
            })

            let myFriendsList = []
            
            for(let i = 0; i < myFriends.length; i++){
                if(typeof this.$store.getters.getAllOnlineUsers[myFriends[i].id] === 'undefined'){
                    myFriendsList.push(this.$store.state.allUsers[myFriends[i].id])
                }
            }

            return myFriendsList
        }
    },

    filters: {
        checkLongName(val){
            if(!val) return
            if(val.length > 10){
                return val.substring(0, 8) + '...'
            }
            return val
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/chat/OnlineUsers.vue